import { Tooltip } from "devextreme-react";
import { Position } from "devextreme-react/tooltip";

type Props = {
  id: string;
};

export default function RetirementAgeTooltip({ id }: Props) {
  return (
    <div id={id} className="absolute left-[100px] top-2 print:left-12 print:top-0">
      <Tooltip
        showEvent="mouseenter"
        hideEvent="mouseleave"
        hideOnOutsideClick={false}
        target={`#${id}`}
      >
        <span>Set as retirement age</span>
        <Position
          at={"top"}
          my={"top"}
          offset={{
            y: "30px",
          }}
        />
      </Tooltip>
    </div>
  );
}
